import { type ForManagerLocationDetail, getLocationsRetrieveQueryKey, locationsRetrieve } from "@sidegigllc/api/client";

export const locationQueryOptions = (locationId: number) => ({
  queryKey: getLocationsRetrieveQueryKey(locationId),
  queryFn: (): Promise<ForManagerLocationDetail> => locationsRetrieve(locationId),
  staleTime: Number.POSITIVE_INFINITY,
});
